import script from "./segment-icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./segment-icon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__